<template>
  <template-list
    :model="$notification"
    :auto-load-list="false"
    title="PUSH уведомления"
  >
    <!--    <template v-slot:actions>-->
    <!--      <v-menu-->
    <!--          :close-on-content-click="false"-->
    <!--          :nudge-right="40"-->
    <!--          max-width="290px"-->
    <!--          min-width="290px"-->
    <!--          offset-y-->
    <!--          transition="scale-transition"-->
    <!--      >-->
    <!--        <template v-slot:activator="{ on }">-->
    <!--          <v-btn depressed class="rounded-lg mr-3" color="primary" v-on="on">-->
    <!--            <v-icon>mdi-filter</v-icon>-->
    <!--          </v-btn>-->
    <!--        </template>-->
    <!--        <v-list class="pt-4 px-3">-->
    <!--          <v-row align="center" class="ma-0" justify="space-between">-->
    <!--            <div class="subtitle-2">Фильтрация</div>-->
    <!--            <v-btn text x-small @click="clearFilter()">Сбросить фильтр</v-btn>-->
    <!--          </v-row>-->

    <!--          <v-text-field-->
    <!--              v-model="$promocodeCondition.filters.search"-->
    <!--              label="Наименование"-->
    <!--              v-bind="inputProps"-->
    <!--          />-->
    <!--          <div class="mt-3 text&#45;&#45;secondary">Срок действия</div>-->
    <!--          <v-row class="ma-0">-->
    <!--            <v-col class="pa-0" cols="6">-->
    <!--              <date-picker-->
    <!--                  v-model="$promocodeCondition.filters.start_date"-->
    <!--                  class="mr-1 body-2"-->
    <!--                  label="С"-->
    <!--                  v-bind="{ ...inputProps, class: undefined }"-->
    <!--              />-->
    <!--            </v-col>-->
    <!--            <v-col class="pa-0" cols="6">-->
    <!--              <date-picker-->
    <!--                  v-model="$promocodeCondition.filters.end_date"-->
    <!--                  class="ml-1 body-2"-->
    <!--                  label="По"-->
    <!--                  v-bind="{ ...inputProps, class: undefined }"-->
    <!--              />-->
    <!--            </v-col>-->
    <!--          </v-row>-->
    <!--          <v-checkbox-->
    <!--              class="ma-0 mt-3"-->
    <!--              dense-->
    <!--              label="Только действующие"-->
    <!--              :value="$promocodeCondition.filters.works"-->
    <!--              @change="-->
    <!--                $promocodeCondition.filters.works = $event || undefined-->
    <!--              "-->
    <!--              hide-details-->
    <!--          />-->
    <!--          <v-row-->
    <!--              align="center"-->
    <!--              class="mx-0 mb-0 mt-3 pb-2 pt-2"-->
    <!--              style="position: sticky; bottom: 0; background: white"-->
    <!--          >-->
    <!--            <v-btn color="primary" small @click="loadList()">Применить</v-btn>-->
    <!--          </v-row>-->
    <!--        </v-list>-->
    <!--      </v-menu>-->
    <!--    </template>-->
    <template v-slot="{ object }">
      <v-col class="pa-0 body-2 pointer">
        <router-link
          :to="{ name: 'notificationItem', params: { notificationId: object.id } }"
          style="width: 100%; height: 100%"
        >
          <v-row
            no-gutters
            align="start link"
          >
            <v-col>
              <div>
                Наименование: <b>{{ object.title }}</b>
              </div>
              <div style="margin-top: 2px">
                Статус отправки: {{ getNotificationStatus(object) }}
              </div>
            </v-col>
          </v-row>
        </router-link>
      </v-col>
    </template>
  </template-list>
</template>

<script>
  export default {
    name: 'NotificationsList',
    components: {},
    data: () => ({
      inputProps: {
        class: 'project-search-input pa-0 rounded-lg mt-3 ',
        dense: true,
        hideDetails: true,
        outlined: true,
        rounded: true,
        style: 'transition: 0.3s',
        clearable: true
      }
    }),
    methods: {
      loadList() {
        this.$notification.filters.notification_type = 'other'
        this.$notification.loadList()
      },
      clearFilter() {
        this.$notification.filters = { notification_type: 'other' }
        this.loadList()
      },
      formatDateTime(date) {
        if (!date) return ''
        return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format('DD.MM.YYYY HH:mm')
      },
      isFutureDate(dateStr) {
        if (!dateStr) return false
        const date = moment.utc(dateStr, 'YYYY-MM-DD HH:mm:ss').local()
        console.log(date.format('YYYY-MM-DD HH:mm:ss'))

        return date > moment()
      },
      getNotificationStatus(notification) {
        if (notification.processed_at) {
          return 'Отправлено'
        }

        if (notification.send_batch_size) {
          return 'Отправлено частично'
        }

        if (notification.send_date && this.isFutureDate(notification.send_date)) {
          return `Будет отправлено ${this.formatDateTime(notification.send_date)}`
        }

        return 'Создано'
      }
    },
    created() {
      this.loadList()
    }
  }
</script>
